/* tslint:disable */
/* eslint-disable */
/**
 * AggregateBusinessManage API
 * 集計行に対する情報を操作するやつ
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * マスタ情報存在確認APIのレスポンスで返ってくるデータの型
 * @export
 * @interface ExistsMasterDataResponse
 */
export interface ExistsMasterDataResponse {
    /**
     * 
     * @type {number}
     * @memberof ExistsMasterDataResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof ExistsMasterDataResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExistsMasterDataResponse
     */
    'message': string;
    /**
     * 
     * @type {ExistsMasterDataResponseResult}
     * @memberof ExistsMasterDataResponse
     */
    'result': ExistsMasterDataResponseResult;
}
/**
 * マスタ情報存在確認APIから返ってくるデータの中身の型定義
 * @export
 * @interface ExistsMasterDataResponseData
 */
export interface ExistsMasterDataResponseData {
    /**
     * マスタ情報が存在するかどうか
     * @type {boolean}
     * @memberof ExistsMasterDataResponseData
     */
    'existsResult': boolean;
    /**
     * 登録済みコード
     * @type {string}
     * @memberof ExistsMasterDataResponseData
     */
    'existsCode': string;
    /**
     * 登録済み値
     * @type {string}
     * @memberof ExistsMasterDataResponseData
     */
    'existsValue': string;
}
/**
 * マスタ情報存在確認APIのレスポンスの型定義
 * @export
 * @interface ExistsMasterDataResponseResult
 */
export interface ExistsMasterDataResponseResult {
    /**
     * 
     * @type {ExistsMasterDataResponseData}
     * @memberof ExistsMasterDataResponseResult
     */
    'data': ExistsMasterDataResponseData;
}
/**
 * 集計登録APIのレスポンスで返ってくるデータの型
 * @export
 * @interface PostAggregateBusinessResponse
 */
export interface PostAggregateBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostAggregateBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostAggregateBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {PostRegisterBusinessResponseResult}
     * @memberof PostAggregateBusinessResponse
     */
    'result': PostRegisterBusinessResponseResult;
}
/**
 * 登録する取引情報
 * @export
 * @interface PostBusinessInfo
 */
export interface PostBusinessInfo {
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'warehouse': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'package': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'supplierNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBusinessInfo
     */
    'isAggregateBusiness': boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'businessName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'unit': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'leadTime': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'leadTimeUnit': string;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfo
     */
    'moq'?: number;
    /**
     * 発注単位
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'orderPackage'?: string;
    /**
     * 販売担当者ID (メアド、カンマ区切りで複数指定可能)
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'aggregateBusinessResponsibleUsers'?: string;
    /**
     * 販売担当者ID (メアド、カンマ区切りで複数指定可能)
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'baseBusinessResponsibleUsers'?: string;
    /**
     * 
     * @type {object}
     * @memberof PostBusinessInfo
     */
    'stdInventoryIndices': object;
    /**
     * key,value形式のユーザー任意項目(24/8/23 現状、顧客台帳ID用を想定)
     * @type {{ [key: string]: string; }}
     * @memberof PostBusinessInfo
     */
    'userCustomParameters'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<PostBusinessInfoArrivalsInner>}
     * @memberof PostBusinessInfo
     */
    'arrivals': Array<PostBusinessInfoArrivalsInner>;
    /**
     * 
     * @type {Array<PostBusinessInfoArrivalsInner>}
     * @memberof PostBusinessInfo
     */
    'mvpInventory': Array<PostBusinessInfoArrivalsInner>;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'executionDate': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'customerNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'salesDestinationName': string;
    /**
     * 
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'salesDestinationNumber': string;
    /**
     * 
     * @type {Array<PostBusinessInfoArrivalsInner>}
     * @memberof PostBusinessInfo
     */
    'salesResults': Array<PostBusinessInfoArrivalsInner>;
    /**
     * 
     * @type {Array<PostBusinessInfoCustomerAnnounceInner>}
     * @memberof PostBusinessInfo
     */
    'customerAnnounce': Array<PostBusinessInfoCustomerAnnounceInner>;
    /**
     * 
     * @type {Array<PostBusinessInfoCustomerAnnounceDailyInner>}
     * @memberof PostBusinessInfo
     */
    'customerAnnounceDaily'?: Array<PostBusinessInfoCustomerAnnounceDailyInner>;
    /**
     * 製造社
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'manufacturer'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'endUser'?: string;
    /**
     * 受領用内示メモ（取引のみ）
     * @type {string}
     * @memberof PostBusinessInfo
     */
    'forecastForReceiptMemo'?: string;
}
/**
 * 
 * @export
 * @interface PostBusinessInfoArrivalsInner
 */
export interface PostBusinessInfoArrivalsInner {
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoArrivalsInner
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoArrivalsInner
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoArrivalsInner
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PostBusinessInfoCustomerAnnounceDailyInner
 */
export interface PostBusinessInfoCustomerAnnounceDailyInner {
    /**
     * 
     * @type {PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth}
     * @memberof PostBusinessInfoCustomerAnnounceDailyInner
     */
    'manageInitiatedYearMonth'?: PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceDailyInner
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceDailyInner
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceDailyInner
     */
    'day'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceDailyInner
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PostBusinessInfoCustomerAnnounceInner
 */
export interface PostBusinessInfoCustomerAnnounceInner {
    /**
     * 
     * @type {PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth}
     * @memberof PostBusinessInfoCustomerAnnounceInner
     */
    'manageInitiatedYearMonth'?: PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceInner
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceInner
     */
    'month'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceInner
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth
 */
export interface PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth {
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBusinessInfoCustomerAnnounceInnerManageInitiatedYearMonth
     */
    'month'?: number;
}
/**
 * 集計登録APIのレスポンスの型定義
 * @export
 * @interface PostRegisterBusinessResponseResult
 */
export interface PostRegisterBusinessResponseResult {
    /**
     * 
     * @type {RegisteredBusinessCounts}
     * @memberof PostRegisterBusinessResponseResult
     */
    'registeredBusinessCounts': RegisteredBusinessCounts;
}
/**
 * 登録する未管理取引の情報
 * @export
 * @interface PostUnmanagedBusinessInfo
 */
export interface PostUnmanagedBusinessInfo {
    /**
     * 集計ID
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'aggregateBusinessId': string;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'baseBusinessId': string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'supplierNumber': string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'supplierName': string;
    /**
     * 商品CD
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'businessNumber': string;
    /**
     * 商品名
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'businessName': string;
    /**
     * 倉庫CD
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'warehouseNumber': string;
    /**
     * 倉庫名
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'warehouse': string;
    /**
     * 容量
     * @type {number}
     * @memberof PostUnmanagedBusinessInfo
     */
    'package': number;
    /**
     * 在庫年月日
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'executionDate': string;
    /**
     * 容量の単位
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'unit': string;
    /**
     * MOQ
     * @type {number}
     * @memberof PostUnmanagedBusinessInfo
     */
    'moq'?: number;
    /**
     * リードタイム
     * @type {number}
     * @memberof PostUnmanagedBusinessInfo
     */
    'leadTime': number;
    /**
     * リードタイムユニット
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'leadTimeUnit': string;
    /**
     * 標準在庫指数
     * @type {object}
     * @memberof PostUnmanagedBusinessInfo
     */
    'stdInventoryIndices': object;
    /**
     * 売上先名
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'customerName': string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'customerNumber': string;
    /**
     * 送り先名
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'salesDestinationName': string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'salesDestinationNumber': string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'endUser'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof PostUnmanagedBusinessInfo
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {Array<UnmanagedInventoryInfo>}
     * @memberof PostUnmanagedBusinessInfo
     */
    'inventories': Array<UnmanagedInventoryInfo>;
    /**
     * 
     * @type {Array<UnmanagedArrivalInfo>}
     * @memberof PostUnmanagedBusinessInfo
     */
    'arrivals': Array<UnmanagedArrivalInfo>;
    /**
     * 
     * @type {Array<UnmanagedCustomerForecast>}
     * @memberof PostUnmanagedBusinessInfo
     */
    'customerAnnounces'?: Array<UnmanagedCustomerForecast>;
    /**
     * 
     * @type {Array<UnmanagedSalesResult>}
     * @memberof PostUnmanagedBusinessInfo
     */
    'salesResults': Array<UnmanagedSalesResult>;
}
/**
 * 未管理取引登録APIのレスポンスで返ってくるデータの型
 * @export
 * @interface PostUnmanagedBusinessResponse
 */
export interface PostUnmanagedBusinessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostUnmanagedBusinessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostUnmanagedBusinessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostUnmanagedBusinessResponse
     */
    'message': string;
    /**
     * 
     * @type {PostUnmanagedBusinessResponseResult}
     * @memberof PostUnmanagedBusinessResponse
     */
    'result': PostUnmanagedBusinessResponseResult;
}
/**
 * 未管理取引登録APIから返ってくるデータの中身の型定義
 * @export
 * @interface PostUnmanagedBusinessResponseData
 */
export interface PostUnmanagedBusinessResponseData {
    /**
     * 集計ID
     * @type {string}
     * @memberof PostUnmanagedBusinessResponseData
     */
    'aggregateBusinessId': string;
    /**
     * 関連取引ID
     * @type {string}
     * @memberof PostUnmanagedBusinessResponseData
     */
    'baseBusinessId': string;
}
/**
 * 未管理取引登録APIのレスポンスの型定義
 * @export
 * @interface PostUnmanagedBusinessResponseResult
 */
export interface PostUnmanagedBusinessResponseResult {
    /**
     * 
     * @type {PostUnmanagedBusinessResponseData}
     * @memberof PostUnmanagedBusinessResponseResult
     */
    'data': PostUnmanagedBusinessResponseData;
}
/**
 * 
 * @export
 * @interface RegisterBusinessPostRequest
 */
export interface RegisterBusinessPostRequest {
    /**
     * upsert処理を実行するかどうかのフラグ
     * @type {boolean}
     * @memberof RegisterBusinessPostRequest
     */
    'useUpsert': boolean;
    /**
     * 登録する取引情報（集計と取引がごっちゃになってるやつ）
     * @type {Array<PostBusinessInfo>}
     * @memberof RegisterBusinessPostRequest
     */
    'postAggregateBusinessInfo': Array<PostBusinessInfo>;
}
/**
 * 
 * @export
 * @interface RegisterUnmanagedBusinessPostRequest
 */
export interface RegisterUnmanagedBusinessPostRequest {
    /**
     * 未管理登録情報のうち、どの情報を登録するのかを指定するための情報
     * @type {string}
     * @memberof RegisterUnmanagedBusinessPostRequest
     */
    'registerBusinessInfoType': string;
    /**
     * 未管理登録情報のうち、どのマスタ情報を登録するのかを指定するための情報
     * @type {Array<string>}
     * @memberof RegisterUnmanagedBusinessPostRequest
     */
    'registerMasterInfoTypes': Array<string>;
    /**
     * 
     * @type {PostUnmanagedBusinessInfo}
     * @memberof RegisterUnmanagedBusinessPostRequest
     */
    'registerBusinessInfo': PostUnmanagedBusinessInfo;
}
/**
 * 登録された取引の数
 * @export
 * @interface RegisteredBusinessCounts
 */
export interface RegisteredBusinessCounts {
    /**
     * 集計取引の数
     * @type {number}
     * @memberof RegisteredBusinessCounts
     */
    'aggregateBusiness': number;
    /**
     * 関連取引の数
     * @type {number}
     * @memberof RegisteredBusinessCounts
     */
    'baseBusiness': number;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 未管理入荷情報
 * @export
 * @interface UnmanagedArrivalInfo
 */
export interface UnmanagedArrivalInfo {
    /**
     * 入荷年
     * @type {number}
     * @memberof UnmanagedArrivalInfo
     */
    'year': number;
    /**
     * 入荷月
     * @type {number}
     * @memberof UnmanagedArrivalInfo
     */
    'month': number;
    /**
     * 入荷数量
     * @type {number}
     * @memberof UnmanagedArrivalInfo
     */
    'amount': number;
}
/**
 * 未管理客先内示情報
 * @export
 * @interface UnmanagedCustomerForecast
 */
export interface UnmanagedCustomerForecast {
    /**
     * 対象年
     * @type {number}
     * @memberof UnmanagedCustomerForecast
     */
    'year': number;
    /**
     * 対象月
     * @type {number}
     * @memberof UnmanagedCustomerForecast
     */
    'month': number;
    /**
     * 
     * @type {UnmanagedCustomerForecastManageInitiatedYearMonth}
     * @memberof UnmanagedCustomerForecast
     */
    'manageInitiatedYearMonth': UnmanagedCustomerForecastManageInitiatedYearMonth;
    /**
     * 内示数量
     * @type {number}
     * @memberof UnmanagedCustomerForecast
     */
    'amount': number;
}
/**
 * 受領年月オブジェクト
 * @export
 * @interface UnmanagedCustomerForecastManageInitiatedYearMonth
 */
export interface UnmanagedCustomerForecastManageInitiatedYearMonth {
    /**
     * 受領年
     * @type {number}
     * @memberof UnmanagedCustomerForecastManageInitiatedYearMonth
     */
    'year': number;
    /**
     * 受領月
     * @type {number}
     * @memberof UnmanagedCustomerForecastManageInitiatedYearMonth
     */
    'month': number;
}
/**
 * 未管理在庫情報
 * @export
 * @interface UnmanagedInventoryInfo
 */
export interface UnmanagedInventoryInfo {
    /**
     * 在庫年
     * @type {number}
     * @memberof UnmanagedInventoryInfo
     */
    'year': number;
    /**
     * 在庫月
     * @type {number}
     * @memberof UnmanagedInventoryInfo
     */
    'month': number;
    /**
     * 在庫数量
     * @type {number}
     * @memberof UnmanagedInventoryInfo
     */
    'amount': number;
}
/**
 * 未管理販売実績情報
 * @export
 * @interface UnmanagedSalesResult
 */
export interface UnmanagedSalesResult {
    /**
     * 対象年
     * @type {number}
     * @memberof UnmanagedSalesResult
     */
    'year': number;
    /**
     * 対象月
     * @type {number}
     * @memberof UnmanagedSalesResult
     */
    'month': number;
    /**
     * 販売実績数量
     * @type {number}
     * @memberof UnmanagedSalesResult
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface UpdateBusinessForInputValuesPostRequest
 */
export interface UpdateBusinessForInputValuesPostRequest {
    /**
     * 登録する取引情報（集計と取引がごっちゃになってるやつ）
     * @type {Array<PostBusinessInfo>}
     * @memberof UpdateBusinessForInputValuesPostRequest
     */
    'updateAggregateBusinessInfo': Array<PostBusinessInfo>;
}
/**
 * 入力エクセル情報更新APIのレスポンスで返ってくるデータの型
 * @export
 * @interface UpdateBusinessForInputValuesResponse
 */
export interface UpdateBusinessForInputValuesResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessForInputValuesResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBusinessForInputValuesResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessForInputValuesResponse
     */
    'message': string;
    /**
     * 
     * @type {UpdateBusinessForInputValuesResponseResult}
     * @memberof UpdateBusinessForInputValuesResponse
     */
    'result': UpdateBusinessForInputValuesResponseResult;
}
/**
 * 入力エクセル情報更新APIのレスポンスの型定義
 * @export
 * @interface UpdateBusinessForInputValuesResponseResult
 */
export interface UpdateBusinessForInputValuesResponseResult {
    /**
     * 
     * @type {UpdatedBusinessInfoCounts}
     * @memberof UpdateBusinessForInputValuesResponseResult
     */
    'updatedBusinessInfoCounts': UpdatedBusinessInfoCounts;
    /**
     * 更新された取引のキー情報
     * @type {Array<string>}
     * @memberof UpdateBusinessForInputValuesResponseResult
     */
    'existBusinessInfoKeys': Array<string>;
}
/**
 * 更新された取引に紐づく情報の数
 * @export
 * @interface UpdatedBusinessInfoCounts
 */
export interface UpdatedBusinessInfoCounts {
    /**
     * 在庫情報の数
     * @type {number}
     * @memberof UpdatedBusinessInfoCounts
     */
    'inventory': number;
    /**
     * 入荷情報の数
     * @type {number}
     * @memberof UpdatedBusinessInfoCounts
     */
    'arrival': number;
    /**
     * 販売実績情報の数
     * @type {number}
     * @memberof UpdatedBusinessInfoCounts
     */
    'salesResult': number;
    /**
     * 客先内示情報の数
     * @type {number}
     * @memberof UpdatedBusinessInfoCounts
     */
    'customerForecast': number;
}
/**
 * 登録する集計情報
 * @export
 * @interface UpsertAggregateBusinessInfo
 */
export interface UpsertAggregateBusinessInfo {
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'warehouse'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'package': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'leadTime': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'leadTimeUnit': string;
    /**
     * 
     * @type {number}
     * @memberof UpsertAggregateBusinessInfo
     */
    'moq'?: number;
    /**
     * 発注単位
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'orderPackage'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertAggregateBusinessInfo
     */
    'stdInventoryIndicesMin': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertAggregateBusinessInfo
     */
    'stdInventoryIndicesMax': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'stdInventoryIndicesUnit': string;
    /**
     * 製造社
     * @type {string}
     * @memberof UpsertAggregateBusinessInfo
     */
    'manufacturer'?: string;
    /**
     * 集計取引担当者ID (メアド、カンマ区切りで複数指定可能)
     * @type {Array<string>}
     * @memberof UpsertAggregateBusinessInfo
     */
    'aggregateBusinessResponsibleUsers'?: Array<string>;
    /**
     * key,value形式のユーザー任意項目(24/8/23 現状、顧客台帳ID用を想定)
     * @type {{ [key: string]: string; }}
     * @memberof UpsertAggregateBusinessInfo
     */
    'userCustomParameters'?: { [key: string]: string; };
}
/**
 * 登録する取引情報
 * @export
 * @interface UpsertBaseBusinessInfo
 */
export interface UpsertBaseBusinessInfo {
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'warehouse'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'warehouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'package': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'businessNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'supplierNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'customerNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'salesDestinationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'salesDestinationNumber': string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof UpsertBaseBusinessInfo
     */
    'endUser'?: string;
    /**
     * 販売担当者ID (メアド、カンマ区切りで複数指定可能)
     * @type {Array<string>}
     * @memberof UpsertBaseBusinessInfo
     */
    'baseBusinessResponsibleUsers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpsertBusinessFromExcelPostRequest
 */
export interface UpsertBusinessFromExcelPostRequest {
    /**
     * 登録する集計情報
     * @type {Array<UpsertAggregateBusinessInfo>}
     * @memberof UpsertBusinessFromExcelPostRequest
     */
    'aggregateBusinesses': Array<UpsertAggregateBusinessInfo>;
    /**
     * 登録する取引情報
     * @type {Array<UpsertBaseBusinessInfo>}
     * @memberof UpsertBusinessFromExcelPostRequest
     */
    'baseBusinesses': Array<UpsertBaseBusinessInfo>;
}
/**
 * 集計登録APIのレスポンスで返ってくるデータの型
 * @export
 * @interface UpsertBusinessFromExcelResponse
 */
export interface UpsertBusinessFromExcelResponse {
    /**
     * 
     * @type {number}
     * @memberof UpsertBusinessFromExcelResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertBusinessFromExcelResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpsertBusinessFromExcelResponse
     */
    'message': string;
    /**
     * 
     * @type {UpsertBusinessFromExcelResponseResult}
     * @memberof UpsertBusinessFromExcelResponse
     */
    'result': UpsertBusinessFromExcelResponseResult;
}
/**
 * 集計登録APIのレスポンスの型定義
 * @export
 * @interface UpsertBusinessFromExcelResponseResult
 */
export interface UpsertBusinessFromExcelResponseResult {
    /**
     * 
     * @type {RegisteredBusinessCounts}
     * @memberof UpsertBusinessFromExcelResponseResult
     */
    'registeredBusinessCounts': RegisteredBusinessCounts;
}
/**
 * ユーザーID存在確認APIのリクエスト
 * @export
 * @interface VerifyUserIdsRequest
 */
export interface VerifyUserIdsRequest {
    /**
     * チェック対象のユーザーID（メール）
     * @type {Array<string>}
     * @memberof VerifyUserIdsRequest
     */
    'userIds': Array<string>;
}
/**
 * ユーザーID存在確認APIのレスポンス
 * @export
 * @interface VerifyUserIdsResponse
 */
export interface VerifyUserIdsResponse {
    /**
     * 
     * @type {number}
     * @memberof VerifyUserIdsResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof VerifyUserIdsResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof VerifyUserIdsResponse
     */
    'message': string;
    /**
     * 
     * @type {VerifyUserIdsResponseResult}
     * @memberof VerifyUserIdsResponse
     */
    'result': VerifyUserIdsResponseResult;
}
/**
 * ユーザーID存在確認結果
 * @export
 * @interface VerifyUserIdsResponseData
 */
export interface VerifyUserIdsResponseData {
    /**
     * 組織内に存在するユーザーID（メール）
     * @type {Array<string>}
     * @memberof VerifyUserIdsResponseData
     */
    'existingUserIds': Array<string>;
    /**
     * 組織内に存在しなかったユーザーID（メール）
     * @type {Array<string>}
     * @memberof VerifyUserIdsResponseData
     */
    'notFoundUserIds': Array<string>;
}
/**
 * ユーザーID存在確認APIのレスポンスの型定義
 * @export
 * @interface VerifyUserIdsResponseResult
 */
export interface VerifyUserIdsResponseResult {
    /**
     * 
     * @type {VerifyUserIdsResponseData}
     * @memberof VerifyUserIdsResponseResult
     */
    'data': VerifyUserIdsResponseData;
}

/**
 * AggregateBusinessApi - axios parameter creator
 * @export
 */
export const AggregateBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {RegisterBusinessPostRequest} registerBusinessPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBusinessPost: async (registerBusinessPostRequest: RegisterBusinessPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerBusinessPostRequest' is not null or undefined
            assertParamExists('registerBusinessPost', 'registerBusinessPostRequest', registerBusinessPostRequest)
            const localVarPath = `/register-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerBusinessPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AggregateBusinessApi - functional programming interface
 * @export
 */
export const AggregateBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AggregateBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {RegisterBusinessPostRequest} registerBusinessPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerBusinessPost(registerBusinessPostRequest: RegisterBusinessPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAggregateBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerBusinessPost(registerBusinessPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AggregateBusinessApi.registerBusinessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AggregateBusinessApi - factory interface
 * @export
 */
export const AggregateBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AggregateBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 集計テーブルに情報を登録する
         * @param {RegisterBusinessPostRequest} registerBusinessPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBusinessPost(registerBusinessPostRequest: RegisterBusinessPostRequest, options?: any): AxiosPromise<PostAggregateBusinessResponse> {
            return localVarFp.registerBusinessPost(registerBusinessPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AggregateBusinessApi - object-oriented interface
 * @export
 * @class AggregateBusinessApi
 * @extends {BaseAPI}
 */
export class AggregateBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 集計テーブルに情報を登録する
     * @param {RegisterBusinessPostRequest} registerBusinessPostRequest 取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AggregateBusinessApi
     */
    public registerBusinessPost(registerBusinessPostRequest: RegisterBusinessPostRequest, options?: RawAxiosRequestConfig) {
        return AggregateBusinessApiFp(this.configuration).registerBusinessPost(registerBusinessPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExistsMasterDataApi - axios parameter creator
 * @export
 */
export const ExistsMasterDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary マスタ情報が存在するかどうかを確認する
         * @param {string} existsTargetItemType 存在チェック対象の項目名 (例: 仕入先マスタが対象なら「supplier」)
         * @param {string} code コード関係の情報を入れる。使用しないなら空文字を入れておく。(容量の時は使わない想定)
         * @param {string} value 名称・容量といった情報を入れる。ここは必ず使用する想定。容量は文字列で受け取る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsMasterDataGet: async (existsTargetItemType: string, code: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'existsTargetItemType' is not null or undefined
            assertParamExists('existsMasterDataGet', 'existsTargetItemType', existsTargetItemType)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('existsMasterDataGet', 'code', code)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('existsMasterDataGet', 'value', value)
            const localVarPath = `/exists-master-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (existsTargetItemType !== undefined) {
                localVarQueryParameter['existsTargetItemType'] = existsTargetItemType;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExistsMasterDataApi - functional programming interface
 * @export
 */
export const ExistsMasterDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExistsMasterDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary マスタ情報が存在するかどうかを確認する
         * @param {string} existsTargetItemType 存在チェック対象の項目名 (例: 仕入先マスタが対象なら「supplier」)
         * @param {string} code コード関係の情報を入れる。使用しないなら空文字を入れておく。(容量の時は使わない想定)
         * @param {string} value 名称・容量といった情報を入れる。ここは必ず使用する想定。容量は文字列で受け取る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsMasterDataGet(existsTargetItemType: string, code: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExistsMasterDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsMasterDataGet(existsTargetItemType, code, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExistsMasterDataApi.existsMasterDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExistsMasterDataApi - factory interface
 * @export
 */
export const ExistsMasterDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExistsMasterDataApiFp(configuration)
    return {
        /**
         * 
         * @summary マスタ情報が存在するかどうかを確認する
         * @param {string} existsTargetItemType 存在チェック対象の項目名 (例: 仕入先マスタが対象なら「supplier」)
         * @param {string} code コード関係の情報を入れる。使用しないなら空文字を入れておく。(容量の時は使わない想定)
         * @param {string} value 名称・容量といった情報を入れる。ここは必ず使用する想定。容量は文字列で受け取る。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsMasterDataGet(existsTargetItemType: string, code: string, value: string, options?: any): AxiosPromise<ExistsMasterDataResponse> {
            return localVarFp.existsMasterDataGet(existsTargetItemType, code, value, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExistsMasterDataApi - object-oriented interface
 * @export
 * @class ExistsMasterDataApi
 * @extends {BaseAPI}
 */
export class ExistsMasterDataApi extends BaseAPI {
    /**
     * 
     * @summary マスタ情報が存在するかどうかを確認する
     * @param {string} existsTargetItemType 存在チェック対象の項目名 (例: 仕入先マスタが対象なら「supplier」)
     * @param {string} code コード関係の情報を入れる。使用しないなら空文字を入れておく。(容量の時は使わない想定)
     * @param {string} value 名称・容量といった情報を入れる。ここは必ず使用する想定。容量は文字列で受け取る。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExistsMasterDataApi
     */
    public existsMasterDataGet(existsTargetItemType: string, code: string, value: string, options?: RawAxiosRequestConfig) {
        return ExistsMasterDataApiFp(this.configuration).existsMasterDataGet(existsTargetItemType, code, value, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RegisterUnmanagedBusinessApi - axios parameter creator
 * @export
 */
export const RegisterUnmanagedBusinessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 未管理登録情報をDBに登録する
         * @param {RegisterUnmanagedBusinessPostRequest} registerUnmanagedBusinessPostRequest 未管理登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUnmanagedBusinessPost: async (registerUnmanagedBusinessPostRequest: RegisterUnmanagedBusinessPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUnmanagedBusinessPostRequest' is not null or undefined
            assertParamExists('registerUnmanagedBusinessPost', 'registerUnmanagedBusinessPostRequest', registerUnmanagedBusinessPostRequest)
            const localVarPath = `/register-unmanaged-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUnmanagedBusinessPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegisterUnmanagedBusinessApi - functional programming interface
 * @export
 */
export const RegisterUnmanagedBusinessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegisterUnmanagedBusinessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 未管理登録情報をDBに登録する
         * @param {RegisterUnmanagedBusinessPostRequest} registerUnmanagedBusinessPostRequest 未管理登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest: RegisterUnmanagedBusinessPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUnmanagedBusinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegisterUnmanagedBusinessApi.registerUnmanagedBusinessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegisterUnmanagedBusinessApi - factory interface
 * @export
 */
export const RegisterUnmanagedBusinessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegisterUnmanagedBusinessApiFp(configuration)
    return {
        /**
         * 
         * @summary 未管理登録情報をDBに登録する
         * @param {RegisterUnmanagedBusinessPostRequest} registerUnmanagedBusinessPostRequest 未管理登録情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest: RegisterUnmanagedBusinessPostRequest, options?: any): AxiosPromise<PostUnmanagedBusinessResponse> {
            return localVarFp.registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RegisterUnmanagedBusinessApi - object-oriented interface
 * @export
 * @class RegisterUnmanagedBusinessApi
 * @extends {BaseAPI}
 */
export class RegisterUnmanagedBusinessApi extends BaseAPI {
    /**
     * 
     * @summary 未管理登録情報をDBに登録する
     * @param {RegisterUnmanagedBusinessPostRequest} registerUnmanagedBusinessPostRequest 未管理登録情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegisterUnmanagedBusinessApi
     */
    public registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest: RegisterUnmanagedBusinessPostRequest, options?: RawAxiosRequestConfig) {
        return RegisterUnmanagedBusinessApiFp(this.configuration).registerUnmanagedBusinessPost(registerUnmanagedBusinessPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpdateBusinessForInputValuesApi - axios parameter creator
 * @export
 */
export const UpdateBusinessForInputValuesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 入力エクセルの情報を元に取引情報を更新する
         * @param {UpdateBusinessForInputValuesPostRequest} updateBusinessForInputValuesPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessForInputValuesPost: async (updateBusinessForInputValuesPostRequest: UpdateBusinessForInputValuesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBusinessForInputValuesPostRequest' is not null or undefined
            assertParamExists('updateBusinessForInputValuesPost', 'updateBusinessForInputValuesPostRequest', updateBusinessForInputValuesPostRequest)
            const localVarPath = `/update-business-for-input-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBusinessForInputValuesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateBusinessForInputValuesApi - functional programming interface
 * @export
 */
export const UpdateBusinessForInputValuesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateBusinessForInputValuesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 入力エクセルの情報を元に取引情報を更新する
         * @param {UpdateBusinessForInputValuesPostRequest} updateBusinessForInputValuesPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest: UpdateBusinessForInputValuesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBusinessForInputValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpdateBusinessForInputValuesApi.updateBusinessForInputValuesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpdateBusinessForInputValuesApi - factory interface
 * @export
 */
export const UpdateBusinessForInputValuesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateBusinessForInputValuesApiFp(configuration)
    return {
        /**
         * 
         * @summary 入力エクセルの情報を元に取引情報を更新する
         * @param {UpdateBusinessForInputValuesPostRequest} updateBusinessForInputValuesPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest: UpdateBusinessForInputValuesPostRequest, options?: any): AxiosPromise<UpdateBusinessForInputValuesResponse> {
            return localVarFp.updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateBusinessForInputValuesApi - object-oriented interface
 * @export
 * @class UpdateBusinessForInputValuesApi
 * @extends {BaseAPI}
 */
export class UpdateBusinessForInputValuesApi extends BaseAPI {
    /**
     * 
     * @summary 入力エクセルの情報を元に取引情報を更新する
     * @param {UpdateBusinessForInputValuesPostRequest} updateBusinessForInputValuesPostRequest 取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateBusinessForInputValuesApi
     */
    public updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest: UpdateBusinessForInputValuesPostRequest, options?: RawAxiosRequestConfig) {
        return UpdateBusinessForInputValuesApiFp(this.configuration).updateBusinessForInputValuesPost(updateBusinessForInputValuesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UpsertBusinessFromExcelApi - axios parameter creator
 * @export
 */
export const UpsertBusinessFromExcelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 取引情報をExcelから登録する
         * @param {UpsertBusinessFromExcelPostRequest} upsertBusinessFromExcelPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBusinessFromExcelPost: async (upsertBusinessFromExcelPostRequest: UpsertBusinessFromExcelPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertBusinessFromExcelPostRequest' is not null or undefined
            assertParamExists('upsertBusinessFromExcelPost', 'upsertBusinessFromExcelPostRequest', upsertBusinessFromExcelPostRequest)
            const localVarPath = `/upsert-business-from-excel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertBusinessFromExcelPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpsertBusinessFromExcelApi - functional programming interface
 * @export
 */
export const UpsertBusinessFromExcelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpsertBusinessFromExcelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 取引情報をExcelから登録する
         * @param {UpsertBusinessFromExcelPostRequest} upsertBusinessFromExcelPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest: UpsertBusinessFromExcelPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpsertBusinessFromExcelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UpsertBusinessFromExcelApi.upsertBusinessFromExcelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UpsertBusinessFromExcelApi - factory interface
 * @export
 */
export const UpsertBusinessFromExcelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpsertBusinessFromExcelApiFp(configuration)
    return {
        /**
         * 
         * @summary 取引情報をExcelから登録する
         * @param {UpsertBusinessFromExcelPostRequest} upsertBusinessFromExcelPostRequest 取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest: UpsertBusinessFromExcelPostRequest, options?: any): AxiosPromise<UpsertBusinessFromExcelResponse> {
            return localVarFp.upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpsertBusinessFromExcelApi - object-oriented interface
 * @export
 * @class UpsertBusinessFromExcelApi
 * @extends {BaseAPI}
 */
export class UpsertBusinessFromExcelApi extends BaseAPI {
    /**
     * 
     * @summary 取引情報をExcelから登録する
     * @param {UpsertBusinessFromExcelPostRequest} upsertBusinessFromExcelPostRequest 取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpsertBusinessFromExcelApi
     */
    public upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest: UpsertBusinessFromExcelPostRequest, options?: RawAxiosRequestConfig) {
        return UpsertBusinessFromExcelApiFp(this.configuration).upsertBusinessFromExcelPost(upsertBusinessFromExcelPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerifyUserIdsApi - axios parameter creator
 * @export
 */
export const VerifyUserIdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ユーザーID（メール）の存在確認を行う
         * @param {VerifyUserIdsRequest} verifyUserIdsRequest 確認対象のユーザーID（メール）配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserIdsPost: async (verifyUserIdsRequest: VerifyUserIdsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyUserIdsRequest' is not null or undefined
            assertParamExists('verifyUserIdsPost', 'verifyUserIdsRequest', verifyUserIdsRequest)
            const localVarPath = `/verify-user-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyUserIdsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerifyUserIdsApi - functional programming interface
 * @export
 */
export const VerifyUserIdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerifyUserIdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ユーザーID（メール）の存在確認を行う
         * @param {VerifyUserIdsRequest} verifyUserIdsRequest 確認対象のユーザーID（メール）配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUserIdsPost(verifyUserIdsRequest: VerifyUserIdsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyUserIdsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUserIdsPost(verifyUserIdsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyUserIdsApi.verifyUserIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VerifyUserIdsApi - factory interface
 * @export
 */
export const VerifyUserIdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerifyUserIdsApiFp(configuration)
    return {
        /**
         * 
         * @summary ユーザーID（メール）の存在確認を行う
         * @param {VerifyUserIdsRequest} verifyUserIdsRequest 確認対象のユーザーID（メール）配列
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserIdsPost(verifyUserIdsRequest: VerifyUserIdsRequest, options?: any): AxiosPromise<VerifyUserIdsResponse> {
            return localVarFp.verifyUserIdsPost(verifyUserIdsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerifyUserIdsApi - object-oriented interface
 * @export
 * @class VerifyUserIdsApi
 * @extends {BaseAPI}
 */
export class VerifyUserIdsApi extends BaseAPI {
    /**
     * 
     * @summary ユーザーID（メール）の存在確認を行う
     * @param {VerifyUserIdsRequest} verifyUserIdsRequest 確認対象のユーザーID（メール）配列
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyUserIdsApi
     */
    public verifyUserIdsPost(verifyUserIdsRequest: VerifyUserIdsRequest, options?: RawAxiosRequestConfig) {
        return VerifyUserIdsApiFp(this.configuration).verifyUserIdsPost(verifyUserIdsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



